<mat-icon class="icon" (click)="scroll(scrollDirection.LEFT)" *ngIf="showNavigation"> keyboard_arrow_left </mat-icon>
<div class="suggestion" #box>
    <div class="suggestion-item" *ngFor="let suggestion of suggestions" (click)="output(suggestion)"
        [title]="suggestion"> {{suggestion}} </div>
</div>
<mat-icon class="icon" (click)="scroll(scrollDirection.RIGHT)" *ngIf="showNavigation"> keyboard_arrow_right </mat-icon>